import { log } from "../../../utilities/index.js";
const resolveLocalAsset = (asset, tracker) => {
  if (typeof asset === "string") {
    return asset;
  }
  if (typeof asset === "object" && Object.prototype.hasOwnProperty.call(asset, "src") && asset !== null) {
    return `${asset.src}`;
  }
  log({ type: "error", message: "The image source was not found", tracker });
  return "";
};
export {
  resolveLocalAsset
};
